import moment from 'moment'

// Shared by the free agents table and the card of a free agent

const POSITION_LABELS = { guard: 'Guard', forward: 'Forward', center: 'Center' }

export function positionLabel(position) {
    return POSITION_LABELS[position] || position
}

export function formatStat(value, percent) {
    if (value === null || value === undefined) return '-'
    const formatted = Number(value).toLocaleString('el-GR', { maximumFractionDigits: 1 })
    return percent ? `${formatted}%` : formatted
}

export function formatDate(date) {
    return date ? moment(date).format('DD/MM/YYYY') : '-'
}
